/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindSellerPublicProfileQueryResponse,
  TelegramProductsControllerFindSellerPublicProfilePathParams,
  TelegramProductsControllerFindSellerPublicProfile401,
} from '../types/TelegramProductsControllerFindSellerPublicProfile.ts';

function getTelegramProductsFindSellerPublicProfileUrl(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProfilePathParams['sellerPublicProfileId'],
) {
  const res = { method: 'GET', url: `/api/telegram/products/seller/${sellerPublicProfileId}` as const };
  return res;
}

/**
 * {@link /api/telegram/products/seller/:sellerPublicProfileId}
 */
export async function telegramProductsFindSellerPublicProfile(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProfilePathParams['sellerPublicProfileId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindSellerPublicProfileQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProfile401>,
    unknown
  >({
    method: 'GET',
    url: getTelegramProductsFindSellerPublicProfileUrl(sellerPublicProfileId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
